// Client feature flags for recording playback (frontend plan §3.3).
//
// Everything sdcard / HLS / continuous is gated because the device + cloud
// contracts it consumes (op:get bridge, device VOD HLS endpoint, EventView eid /
// snapshot_url) are not all live yet. The cloud half can ship independently.
//
// Flags read Vite build-time env (VITE_*), defaulting OFF, so a production build
// opts in explicitly. Tests can override via setFlagOverride.

const overrides: Partial<Record<RecFlag, boolean>> = {};

export type RecFlag =
  /** sdcard op:get queries + reconcile sdcard half + /snap/. */
  | 'pb.sdcard'
  /** View-2 continuous timeline component + route. */
  | 'pb.continuousTimeline'
  /** Remote (WebRTC data-channel) media transport beyond same-LAN (spec D8 / §8A.3). */
  | 'REC_FEAT_PLAYBACK_REMOTE';

const ENV_KEY: Record<RecFlag, string> = {
  'pb.sdcard': 'VITE_REC_PB_SDCARD',
  'pb.continuousTimeline': 'VITE_REC_PB_CONTINUOUS',
  REC_FEAT_PLAYBACK_REMOTE: 'VITE_REC_FEAT_PLAYBACK_REMOTE',
};

function envTruthy(v: unknown): boolean {
  return v === '1' || v === 'true' || v === true;
}

/** True when the flag is enabled (test override wins, else VITE_* env, else OFF). */
export function recFlag(flag: RecFlag): boolean {
  if (flag in overrides) return overrides[flag]!;
  const env = import.meta.env as Record<string, unknown>;
  return envTruthy(env[ENV_KEY[flag]]);
}

/** Test-only: force a flag value (pass undefined to clear). */
export function setFlagOverride(flag: RecFlag, value: boolean | undefined): void {
  if (value === undefined) delete overrides[flag];
  else overrides[flag] = value;
}
